export default __webpack_public_path__ + "static/media/Avatar-6.fb9121dc.png";